import { combineReducers } from 'redux'
import auth from '../admin/modules/Authintication/store/reducer'
import home from '../admin/modules/home/store/reducer'
import common from '../admin/modules/Common/store/reducer'
import dashboard from '../admin/modules/Dashboard/store/reducer'

export default combineReducers({ auth, home, common, dashboard })
